import url from '~/helpers/url'

export default (user, field = 'profile_photo') => url(user && user[field] ? user[field] : 'user-placeholder.png')
